import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Validation } from '@ps/web-shared-components';
import type { ErrorOrPromise, Validator } from '@ps/web-shared-validators';
import {
  getCheckUserId,
  minLength as minLengthFactory,
  mustNotContain as mustNotContainFactory,
  noWhiteStartOrEnd
} from '@ps/web-shared-validators';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import TextInput from '../TextInput/TextInput';

import {
  TXTWCL_N0_characters_or_more,
  TXTWCL_Please_try_again_without_using_ELL,
  TXTWCL_Username
} from './Username.messages.json';

const fieldName = 'userId';
const maxLength = 15;
const minLength = 4;

interface UserNameProps {
  autocomplete?: string;
}

const Username: React.FC<UserNameProps> = ({ autocomplete = 'off' }) => {
  const options = useSelector(select.cms.getRequestOptions);
  const site = useSelector(select.cms.getSiteId);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);

  const checkUserId = useMemo(
    () =>
      getCheckUserId(
        // @ts-ignore // TODO: fix on api consolidation
        options,
        [mustNotContainFactory('  ', TXTWCL_Please_try_again_without_using_ELL), noWhiteStartOrEnd],
        site
      ) as Validator<ErrorOrPromise>,
    [options, site]
  );

  return (
    <TextInput
      id="Username"
      autoCapitalize="off"
      name={fieldName}
      maxLength={maxLength}
      autoComplete={autocomplete}
      validationVariant={Validation.ImmediateList}
      label={TXTWCL_Username}
      validators={[
        minLengthFactory(minLength, { ...TXTWCL_N0_characters_or_more, values: { 0: minLength } }),
        checkUserId
      ]}
      autoFocus={isAutofocusEnabled}
    />
  );
};

export default Username;
